import React from 'react';
import {
  Container, Dimmer, Table, Card,
  Button, Avatar, Page
} from "tabler-react";
import SearchInput from '../../components/searchInput';

const RecordsTable = ({
  headers,
  records,
  openMainModal,
  loading,
  reload,
  searchQuery,
  onSearch
}) => {

  return (
    <Container>
      <Page.Header>
        <Page.Title>Notifications</Page.Title>
      </Page.Header>
      <Card>
        <Dimmer active={loading} loader={loading}>
          <Card.Header>
            <Card.Options>
              <SearchInput value={searchQuery} onSubmit={onSearch} />
              <Button
                className="ml-2"
                icon="plus"
                color="primary"
                size="md"
                onClick={() => openMainModal('notification-create', null, reload)}
              >
                Create notification
              </Button>
            </Card.Options>
          </Card.Header>
          {!loading && records.length < 1 ?
            <div className="alert alert-primary m-0">
              No notifications to show!
            </div>
            :
            <Table
              hasOutline
              striped
            >
              <Table.Header>
                {headers.map((head, i) => (
                  <Table.ColHeader
                    key={`tableHeader-${i}`}
                  >
                    {head}
                  </Table.ColHeader>
                ))}
                <Table.ColHeader>Actions</Table.ColHeader>
              </Table.Header>
              <Table.Body>
                {records.map((r, i) => (
                  <Table.Row key={i}>
                    {Object.keys(r).map((k, i) => {
                      if (k === 'id') { return false }
                      if (k === 'image') {
                        return (<Table.Col>
                          <Avatar
                            size="sm"
                            imageURL={r['image']}
                          />
                        </Table.Col>);
                      } else {
                        return (<Table.Col>{r[k]}</Table.Col>);
                      }
                    })}
                    <Table.Col>
                      <Button
                        outline
                        color="secondary"
                        icon=""
                        className="mr-2"
                        size="sm"
                        onClick={() => openMainModal('notification-edit', r['id'], reload)}
                      >
                        Edit
                      </Button>

                      <Button
                        outline
                        color="danger"
                        icon=""
                        className="mr-2"
                        size="sm"
                        onClick={() => openMainModal('notifications--delete', r['id'], reload)}
                      >
                        Delete
                      </Button>

                      <Button
                        color="secondary"
                        icon=""
                        size="sm"
                        className="mr-2"
                        onClick={() => openMainModal('notification-user', r['id'])}
                      >
                        Send to Users
                      </Button>
                      <Button
                        color="secondary"
                        icon=""
                        size="sm"
                        onClick={() => openMainModal('notification-alluser', r['id'])}
                      >
                        Send By Role
                      </Button>
                    </Table.Col>
                  </Table.Row>
                ))}
              </Table.Body>

            </Table>
          }
        </Dimmer>
      </Card>

    </Container>

  );
}

export default RecordsTable;